import { getServiceNameWithTags } from 'util';

export default function UserServices({ data }) {
  const { services } = data;

  if (!services || services?.length === 0) return;

  return (
    <div className="p-24 border-light-purple radius-24 mt-12">
      <h3 className="f16 mb-15">Services</h3>
      {services.map((service) => (
        <div
          className="flex-row justify-between f13 align-start"
          key={service.uuid}
        >
          <p>{getServiceNameWithTags(service)}</p>
          <p>{service?.price?.localized ? service.price.localized : '-'}</p>
        </div>
      ))}
    </div>
  );
}
